<template>

    <main-content >
        <action-bar>
            <button class="back-btn ml-2" @click="$router.push('/stores/'+store_hashid+'/products')">
                {{ $t('label.back') }}<i class="pl-2 fa fa-arrow-left" style="color: white;"></i>
            </button>
        </action-bar>

        <kt-panel >

            <tabs>
                <tab :name=" $t('label.with') + ' ' + $t('label.amount') + ' ' + $t('label.discount')" :selected="true">
                    <kt-panel-body>

                        <kt-form-section>
                            <form @submit.prevent="submitFixValue" id="product_form1">
                                <kt-row>
                                    <kt-col lg="6" md="6" xs="12">

                                        <kt-form-group>
                                            <kt-form-label for="amount">
                                                {{ $t('label.amount') }} {{ $t('label.discount') }}
                                            </kt-form-label>
                                            <kt-form-control
                                                    dir="ltr"
                                                    id="amount2"
                                                    name="amount"
                                                    v-model="coupon.amount"
                                            >
                                            </kt-form-control>
                                        </kt-form-group>

                                    </kt-col>
                                </kt-row>
                                <div class="ml-auto">
                                    <kt-button type="submit" class="ml-2"  variant="success" id="submit_btn">{{ $t('tag.submit') }}<i class="pl-2 fa fa-arrow-left"></i></kt-button>
                                </div>
                            </form>
                        </kt-form-section>

                    </kt-panel-body>
                </tab>
                <tab :name=" $t('label.with') + ' ' + $t('label.percent') + ' ' + $t('label.discount')">
                    <kt-panel-body>
                        <kt-form-section>
                            <form @submit.prevent="submitPercentOff" id="product_form2">
                                <kt-row>
                                    <kt-col lg="6" md="6" xs="12">
                                        <kt-form-group>
                                            <kt-form-label for="percent">
                                                {{ $t('label.percent') }} {{ $t('label.discount') }}
                                            </kt-form-label>
                                            <kt-form-control
                                                    dir="ltr"
                                                    id="percent"
                                                    name="percent"
                                                    v-model="coupon.percent"
                                            >
                                            </kt-form-control>

                                        </kt-form-group>
                                        <kt-form-group>
                                            <kt-form-label for="max">
                                                {{ $t('label.max') }} {{ $t('label.until') }} {{ $t('label.amount') }}
                                            </kt-form-label>
                                            <kt-form-control
                                                    dir="ltr"
                                                    id="max"
                                                    name="max"
                                                    v-model="coupon.max"
                                            >
                                            </kt-form-control>

                                        </kt-form-group>

                                    </kt-col>

                                </kt-row>
                                <div class="ml-auto">
                                    <kt-button  type="submit" class="ml-2"  variant="success" id="submit_btn_percent">{{ $t('tag.submit') }}<i class="pl-2 fa fa-arrow-left"></i></kt-button>
                                </div>
                            </form>
                        </kt-form-section>

                    </kt-panel-body>
                </tab>
            </tabs>


        </kt-panel>
    </main-content>
</template>

<script>

    import mainContent from '@/components/main-content'
    import tab from './components/tab'
    import tabs from './components/tabs'
    import { KTApp } from '@/plugins/core/app'
    import $ from "jquery";
    import {productService} from "../../common/api.service";
    import ActionBar from "../../components/custom/action-bar";
    export default {
        components: {
            ActionBar,
            mainContent,
            tab,
            tabs,
        },
        data() {
            return {
                store_slug: this.$route.params.store,
                store_hashid: this.$route.params.store_hashid,
                coupon:{
                    amount:'',
                    percent:'',
                    max:'',
                }


            }
        },
        methods:{
            submitPercentOff(e){

                let form = $(e.target);

                form.validate({
                    rules: {
                        code: {
                            required: true,
                        },
                        percent: {
                            required: true,
                            number:true
                        },
                        max: {
                            required: true,
                            number:true
                        },
                    },
                });

                let btn = $('#submit_btn_percent');
                KTApp.progress(btn);
                productService.createCoupon(this.coupon,this.store_hashid)
                    .then(response => {
                        this.showMsg(form, 'success','تخفیف بروزرسانی شد');
                        this.coupon.code = '';
                        this.coupon.percent = '';
                        this.coupon.max = '';
                    })
                    .catch(({response}) => {
                        if(response.data) {
                            this.showMsg(form, 'danger',response.data.message);
                            form.validate().showErrors(response.data.data);
                        }
                    })
                    .finally(() => {
                        KTApp.unprogress(btn)
                    })

            },
            submitFixValue(e){
                let form = $(e.target);

                form.validate({
                    rules: {
                        code: {
                            required: true,
                        },
                        amount: {
                            required: true,
                            number:true
                        },
                    },
                });

                let btn = $('#submit_btn_percent');
                KTApp.progress(btn);
                productService.createCoupon(this.coupon,this.store_hashid)
                    .then(response => {
                        this.showMsg(form, 'success','تخفیف بروزرسانی شد');
                        this.coupon.code = '';
                        this.coupon.amount = '';
                    })
                    .catch(({response}) => {
                        if(response.data) {
                            this.showMsg(form, 'danger',response.data.message);
                            form.validate().showErrors(response.data.data);
                        }
                    })
                    .finally(() => {
                        KTApp.unprogress(btn)
                    })

            }
        }

    }
</script>
<style >
    .back-btn{
        padding: 10px 20px;
        border-radius: 5px;
        background-color: #4AB3F4;
        border-color: #4AB3F4;
        color: #ffffff;
        border: 0;
    }

</style>